import { render, staticRenderFns } from "./ProtocolsRemovedFromControl.vue?vue&type=template&id=63d08d66"
import script from "./ProtocolsRemovedFromControl.vue?vue&type=script&lang=js"
export * from "./ProtocolsRemovedFromControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports